export default __webpack_public_path__ + "static/media/edit.827a6b53.svg";